import React from 'react';
import './ComingSoonSection.scss';

interface ComingSoonSectionProps {
  title?: string;
}

// Моковые данные
const mockData: Required<ComingSoonSectionProps> = {
  title: 'Page Under Development',
};

const ComingSoonSection: React.FC<ComingSoonSectionProps> = ({
  title = mockData.title,
}) => {
  return (
    <div className="ComingSoon">
      <div className="ComingSoon__container">
        <h2 className="ComingSoon__title">{title}</h2>
<h5>under construction</h5>
        <div className="ComingSoon__progress">
          <div className="ComingSoon__progress-bar">
            <div className="ComingSoon__progress-fill"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonSection;
